<template>
  <div :class="[this.$store.state.isMobile ? 'nav-bar2' : 'nav-bar1']" v-loading.fullscreen="fullscreenLoading">
    <div class="nav-box">
      <!-- logo -->
      <div class="nav-logo">
        <el-image :src="logo" fit="cover" @click="goHome"></el-image>
      </div>
      <!-- 导航 -->
      <div class="nav-menu">
        <img src="@/assets/menu.png" alt="" style="width: 50%" v-show="!drawer" @click="openMenu" />
        <img src="@/assets/close.png" alt="" style="width: 34%" v-show="drawer" @click="handleClose" />
      </div>
      <div class="nav-right" @click="closeNavDetail">
        <!-- <router-link to="/">Home</router-link> | -->
        <!-- <router-link to="/about">About</router-link> -->
        <ul>
          <li @click.stop="clickNav(item, index)" :class="[currentIndex == index && detailDisplay ? 'selectNav' : '']"
            v-for="(item, index) in navData" :key="index">
            {{ item.name }}
            <img src="@/assets/down.png" alt="" style="width: 1rem" v-show="currentIndex != index || !detailDisplay" />
            <img src="@/assets/up.png" alt="" style="width: 1rem" v-show="currentIndex == index && detailDisplay" />
          </li>
        </ul>
      </div>
    </div>
    <div class="nav-detail" :style="{ display: detailDisplay ? 'block' : 'none' }">
      <div class="menu-box" v-if="isHasC">
        <div class="menu-list" v-for="(e1, index) in menuList" :key="index">
          <div class="menu-title">
            <span>{{ e1.name }}</span>
          </div>
          <div class="menu-item" v-for="(e2, index2) in e1.productList" :key="index2"
            @click="goDetail(e2.pageCategory, e2.id)">
            <span>{{ e2.productName }}</span>
          </div>
        </div>
      </div>
      <div class="menu-box" v-else>
        <div class="menu-list" v-for="(e1, index1) in menuList" :key="index1">
          <div class="menu-title" style="cursor: pointer" @click="goDetail(e1.pageCategory, e1.id)">
            <span>{{ e1.productName }}</span>
          </div>
          <!-- <div
            class="menu-item"
            v-for="(e2, index) in e1.productList"
            :key="index"
          >
            <span>{{ e2.productName }}</span>
          </div> -->
        </div>
      </div>
    </div>
    <el-drawer class="drawer" title="" :visible.sync="drawer" direction="rtl" append-to-body :before-close="handleClose"
      size="100%" :withHeader="false">
      <div class="drawer-body">
        <div v-for="(item, index) in navData" :key="index" class="draw-list" @click="openMenuItem(item)">
          <span>{{ item.name }}</span>
          <img src="@/assets/arrow-right.png" alt="" style="width: 1rem" />
        </div>
      </div>
    </el-drawer>
    <el-drawer class="drawer" title="" :visible.sync="drawerInner" direction="rtl" append-to-body
      :before-close="handleCloseInner" size="100%" :withHeader="false">
      <div class="drawer-body">
        <div class="back" @click="handleCloseInner">
          <img src="@/assets/arrow-left.png" alt="" style="width: 1rem; margin-right: 0.4rem" />
          <span> 返回主菜单 </span>
        </div>
        <div class="menu-title">
          <span>{{ menuInnerTitle }}</span>
        </div>
        <div class="menu-drawer">
          <div v-if="isHasC">
            <el-collapse v-model="activeName" accordion>
              <el-collapse-item v-for="(e1, index) in menuList" :key="index" :title="e1.name" :name="index">
                <div class="inner-item" v-for="(e2, index2) in e1.productList" :key="index2"
                  @click="goDetail(e2.pageCategory, e2.id)">
                  <span>{{ e2.productName }}</span>
                </div>
              </el-collapse-item>
            </el-collapse>
          </div>

          <div class="menu-drawer" v-else>
            <div class="inner-list" v-for="(e1, index1) in menuList" :key="index1">
              <div class="" style="cursor: pointer" @click="goDetail(e1.pageCategory, e1.id)">
                <span>{{ e1.productName }}</span>
              </div>
            </div>
          </div>
        </div>
      </div>
    </el-drawer>
  </div>
</template>
<script>
import { getNavigationBarData, getListIds } from "@/api/front";
export default {
  name: "navbar",
  data() {
    return {
      logo: require("@/assets/yunda.png"),
      // navList: [],
      currentIndex: null,
      detailDisplay: false,
      navData: this.$store.state.navList,
      menuList: [],
      isHasC: true,
      fullscreenLoading: false,

      drawer: false,
      drawerInner: false,
      activeName: "1",
      menuInnerTitle: "",
      newsEventsListId: '',
      officialWebsiteListId: ''
    };
  },
  created() {
    this.getNavList();
    this.getKey();
  },
  // mounted(){
  //   thinavData = this.$store.state.navList
  // },
  methods: {
    goHome() {
      this.$router.push("/");
      window.scrollTo(0, 0);
    },
    clickNav(item, index) {
      if (this.currentIndex == index) {
        this.currentIndex = index;
        this.detailDisplay = !this.detailDisplay;
      } else {
        this.currentIndex = index;
        this.detailDisplay = true;
        this.getNavDetail(item.id);
      }
    },
    // 通用点击关闭导航菜单
    closeNavDetail() {
      this.detailDisplay = false;
    },
    getNavDetail(id) {
      this.navData.forEach((e) => {
        if (e.id === id) {
          if (e.children) {
            this.isHasC = true;
            this.menuList = e.children;
          } else {
            this.isHasC = false;
            this.menuList = e.productList;
          }
        }
      });
    },
    getNavList() {
      // this.fullscreenLoading = true;
      getNavigationBarData().then((res) => {
        let data = res.data.filter((e) => e.name !== "首页");
        this.navData = this.handleTree(data);
        // this.fullscreenLoading = false;
        console.log('导航', this.navData);

      });
    },
    getKey() {
      getListIds().then(res => {
        this.newsEventsListId = res.data.newsEventsListId;
        this.officialWebsiteListId = res.data.officialWebsiteListId;

      })
    },
    goDetail(type, id) {
      // if (this.currentIndex == this.navData.length - 1) {
        // return;
      // } else {
        let path = "";
        if (id == this.newsEventsListId ) {
          path='dynamic-list';
          let routerJump = this.$router.resolve({
            path: path,
            query: { category: '0' },

          });
          window.open(routerJump.href, "_blank");
        }else if(id == this.officialWebsiteListId){
          path='tech-list';
          let routerJump = this.$router.resolve({
            path: path,
          });
          window.open(routerJump.href, "_blank");
        } else {
          if (type == 0) {
            path = "/product-detail";
          } else if(type == 2){
            path = "/product-detail1";
          } else {
            path = "/article-detail";
          }
          let routerJump = this.$router.resolve({
            path: path,
            query: { id: id, category: type },
          });
          window.open(routerJump.href, "_blank");
        }

      // }
    },

    openMenu() {
      this.drawer = true;
    },
    handleClose() {
      this.drawer = false;
      this.handleCloseInner();
    },
    openMenuItem(e) {
      this.getNavDetail(e.id);
      this.menuInnerTitle = e.name;
      this.drawerInner = true;
    },
    handleCloseInner() {
      this.menuInnerTitle = "";
      this.drawerInner = false;
    },
  },
};
</script>
<style lang="scss">
.nav-bar1 {
  width: 100vw;
  // min-width: 1440px;
  height: 6rem;
  font-size: 1.3rem;

  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: #fff;

  .nav-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    margin: 0 auto;
    padding: 0 0 0 10rem;
    box-sizing: border-box;

    .nav-logo {
      // height: 60px;
      width: 16rem;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .nav-menu {
      display: none;
    }

    .nav-right {
      width: calc(100% - 16rem);
      height: 100%;
      padding-right: 10rem;
      // height: 60px;
      display: flex;
      justify-content: flex-end;
      align-items: center;

      ul {
        width: 100%;
        display: flex;
        justify-content: flex-end;
        list-style: none;
        box-sizing: border-box;

        li {
          cursor: pointer;
          margin-left: 5rem;
        }

        .selectNav {
          font-weight: 600;
        }
      }
    }
  }

  .nav-detail {
    // height: 400px;
    min-height: 16rem;
    width: 100%;
    // min-width: 1440px;
    background-color: #fff;
    position: fixed;
    top: 6rem;
    left: 0;
    border-top: 1px solid #e7e7e7;

    .menu-box {
      width: 100%;
      height: 100%;
      padding: 3rem 10rem;
      box-sizing: border-box;
      display: flex;
      justify-content: flex-start;

      .menu-list {
        text-align: left;
        // width: 20%;
        flex: 1;
        margin-right: 1.5rem;

        .menu-title {
          border-bottom: 1px solid #e7e7e7;
          line-height: 3;
          font-size: 1.5rem;
          font-weight: 500;
        }

        .menu-item {
          line-height: 2;
          color: #656565;

          span {
            &:hover {
              cursor: pointer;
              color: #000;
            }
          }
        }
      }
    }
  }
}

.nav-bar2 {
  width: 100vw;
  // min-width: 1440px;
  height: 4rem;
  // font-size: 1.3rem;

  position: fixed;
  top: 0;
  z-index: 9999;
  background-color: #fff;
  box-shadow: 0 0 10px #ddd;

  .nav-box {
    width: 100%;
    height: 100%;
    display: flex;
    justify-content: space-between;
    align-items: center;
    // margin: 0 auto;
    padding: 0 1rem;
    box-sizing: border-box;

    .nav-logo {
      // height: 60px;
      width: 8rem;
      display: flex;
      align-items: center;
      cursor: pointer;
    }

    .nav-menu {
      text-align: right;
    }

    .nav-right {
      width: 70%;
      // height: 60px;
      display: none;
      // justify-content: flex-end;
    }
  }

  // ::v-deep.el-drawer__body{
  //   background-color: #efefef;
  //   padding:5rem 1rem;
  // }
}

.drawer {
  .drawer-body {
    width: 100%;
    height: 100%;
    background-color: #fefefe;
    padding: 5rem 1.5rem;

    .draw-list {
      height: 4rem;
      display: flex;
      justify-content: space-between;
      align-items: center;
      border-bottom: 0.1rem solid #ddd;
      font-size: 1rem;
    }

    .back {
      display: flex;
      align-items: center;
      color: #707070;
    }

    .menu-title {
      padding: 1.5rem 0 0;
      font-size: 1.2rem;
      font-weight: 500;
    }

    .menu-drawer {
      margin-top: 1.5rem;

      .el-collapse-item__header {
        font-size: 1rem;
        font-weight: normal;
        height: 4rem;
      }

      .el-collapse-item__content {
        font-size: 1rem;
      }

      .inner-list {
        padding: 1rem 0;
        font-size: 1rem;
        color: #303133;
        border-bottom: 0.1rem solid #ddd;
      }

      .inner-item {
        // width: 80%;
        padding: 0.5rem 1rem;
      }
    }
  }
}
</style>
